<template>
  <div id="title" class="invite avenir">
    <!-- <img class="topImg" src="https://cdn.anyteach.cn/img/invite/cash.png?imageView2/0/w/400" /> -->
    <div class="top">
      <div class="title">
        <h1>邀请购课</h1>
        <p v-if="$store.state.info.identity && user.identity > 1">
          <i class="anyteachicon anyteach-shenfen1" />
          {{ $store.state.info.identity[user.identity] }}
        </p>
        <p v-else>
          <i class="anyteachicon anyteach-check-circle" />可获得高额收入
        </p>
      </div>
    </div>
    <router-link to="/invite/history" tag="div" class="inviteRecord btn button red">
      查看邀请记录
      <p class="right">
        {{ rule && rule.invite ? rule.invite + " 人" : "暂无邀请" }}
        <i
          class="anyteachicon anyteach-next1"
        />
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Top",
  props: ["rule"],
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
#title {
  z-index: 1;
  background: none;
  position: relative;
  padding-top: 5px;
}

.top {
  // padding-top: 65px;
  padding-top: 20px;
}
.topImg {
  position: absolute;
  z-index: 0;
  width: 180px;
  right: 0;
}

.btn {
  padding: 13px 15px;
  @include card();
}
.top .title {
  padding: 10px 0;
  h1,
  p {
    line-height: 1;
    margin: 0;
    opacity: 1;
  }

  p {
    font-size: 0.9rem;
    font-weight: 400;
    padding: 10px 0 0 0;
    i {
      color: $red;
      margin: 0 3px 0 0;
      font-size: inherit;
    }
  }
}

.inviteRecord {
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0 0 25px;
  width: 100%;

  .right {
    @include avenir();
    float: right;
    font-weight: 400;
    opacity: 0.7;
    font-size: 0.85rem;
    i {
      margin-left: 0px;
      font-size: 0.85rem;
    }
  }
}
</style>
